import { SpecialCheckBoxesInputGroup } from "./SpecialCheckBoxesInputGroup";
import { AreaInput } from "./AreaInput";
import { FormActions } from "./FormActions";
import ConfirmationModal from "@components/modal/ConfirmationModal";
import FooterError from "@pages/activityBuilder/modules/FooterError";
import type { TranslationKey } from "@typedefs/modulesInterfaces";
import { FieldType } from "@typedefs/modulesInterfaces";
import { useCustomTranslationHandler } from "@app/hooks";

interface SetupAssistantFormContentProps {
  modulesInput: {
    inputName: string;
    label: TranslationKey;
    options: { name: TranslationKey; id: string | number }[];
    type: FieldType.CHECKBOXES;
    disabled?: boolean;
  };
  isEdit: boolean;
  isLoading: boolean;
  isSubmitting: boolean;
  isValid: boolean;
  isError: boolean;
  errorMsg?: string;
  showConfirmModal: boolean;
  errors: any;
  touched: any;
  onReturn?: () => void;
  onCancel: () => void;
  onConfirm: (submitForm: () => Promise<void>) => void;
  submitForm: () => Promise<void>;
}

export const SetupAssistantFormContent = ({
  modulesInput,
  isEdit,
  isLoading,
  isSubmitting,
  isValid,
  isError,
  errorMsg,
  showConfirmModal,
  errors,
  touched,
  onReturn,
  onCancel,
  onConfirm,
  submitForm,
}: SetupAssistantFormContentProps) => {
  const translationHandler = useCustomTranslationHandler();
  const translatedMessage = translationHandler("activity.confirm_update");

  return (
    <>
      <SpecialCheckBoxesInputGroup
        {...modulesInput}
        disabled={modulesInput.disabled || isLoading}
      />
      <AreaInput />

      <FormActions
        isEdit={isEdit}
        isLoading={isSubmitting}
        isValid={isValid}
        isError={isError}
        onReturn={onReturn}
      />

      <FooterError
        footerError={errorMsg}
        errors={errors}
        touched={touched}
      />

      <ConfirmationModal
        open={showConfirmModal}
        onCancel={onCancel}
        onConfirm={() => onConfirm(submitForm)}
        message={translatedMessage}
        headerText="main.attention"
      />
    </>
  );
}; 